var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Row } from "react-bootstrap";
import padding from "@irati/ui/src/global/padding";
import { greys } from "@irati/ui/src/global/colors";
var StyledRow = styled(function (_a) {
    var isEditRowView = _a.isEditRowView, rest = __rest(_a, ["isEditRowView"]);
    return React.createElement(Row, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 5px;\n  margin-top: ", ";\n  padding: ", " 0;\n  transition: border-color 80ms ease-in;\n  position: relative;\n  border-color: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  cursor: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  border-radius: 5px;\n  margin-top: ", ";\n  padding: ", " 0;\n  transition: border-color 80ms ease-in;\n  position: relative;\n  border-color: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  cursor: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), padding.tiny, padding.tiny, function (props) { return (props.isEditRowView ? greys.mediumLight : ""); }, function (props) { return (props.isEditRowView ? "dashed" : ""); }, function (props) { return (props.isEditRowView ? "2px" : ""); }, function (props) { return (props.isEditRowView ? "pointer" : "inherit"); }, function (props) { return (props.isEditRowView ? greys.mediumDark : "transparent"); });
var HomePageRow = function (props) { return React.createElement(StyledRow, __assign({}, props)); };
export default HomePageRow;
var templateObject_1;
